import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalIsSchema = z.object({
    rfi_cclasstribis: z.string(),
    rfi_cst: z.string(),
    rfi_destino: z.enum(DestinoNotaFiscal).nullable(),
    rfi_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rfi_empresa_idpk: z.number(),
    rfi_estado_especifico: z.string().nullable(),
    rfi_idpk: z.number(),
    rfi_motivo: z.number().nullable(),
    rfi_perfil_cliente: z.enum(ClienteFiscalPerfil),
    rfi_pis: z.number(),
    rfi_pisespec: z.number(),
    rfi_regra_fiscal_idpk: z.number(),
    rfi_tipo: z.enum(NotaFiscalTipo).nullable(),
    rfi_tipo_cliente: z.enum(TipoCliente).nullable(),
    rfi_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
});

type RegraFiscalIs = z.infer<typeof RegraFiscalIsSchema>;

export type RegraFiscalIsBody = PartialUndefinedOrNull<RegraFiscalIs> & TableEditItem;
